module.exports = __webpack_public_path__ + "img/upload-arrow.278e046c.svg";